import React from 'react';
import { Switch, FormControlLabel } from '@material-ui/core';

export const renderToggleInput = (field) => (
  <FormControlLabel
    control={
      <Switch
        label={field.label}
        checked={field.input.value}
        onChange={field.input.onChange}
        labelPlacement="end"
      />
    }
    labelPlacement="start"
    label={field.label}
  />
);



// WEBPACK FOOTER //
// ./src/components/forms/Toggle.js